// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer { 
  background: linear-gradient(135deg, #6b1c2a 0%, #8a1e2b 50%, #9e2536 100%); 
  color: #f8d7da; 
  padding: 32px 0; 
  border-top: 1px solid rgba(248, 215, 218, 0.1);
  box-shadow: 0 -4px 20px rgba(158, 37, 54, 0.1);
}
.footer-inner { 
  display: flex; 
  align-items: center; 
  justify-content: space-between; 
  font-weight: 500;
}
.footer a { 
  color: #f8d7da; 
  text-decoration: none; 
  opacity: 0.9; 
  transition: all 0.3s ease;
}
.footer a:hover { 
  opacity: 1; 
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.footer-links { display:flex; gap:16px; }
@media (max-width: 900px) { 
  .footer-inner { 
    flex-direction: column; 
    gap: 12px; 
    text-align: center;
  } 
  
  .footer {
    padding: 24px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,0EAA0E;EAC1E,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,cAAc;EACd,yCAAyC;AAC3C;AACA,gBAAgB,YAAY,EAAE,QAAQ,EAAE;AACxC;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".footer { \n  background: linear-gradient(135deg, #6b1c2a 0%, #8a1e2b 50%, #9e2536 100%); \n  color: #f8d7da; \n  padding: 32px 0; \n  border-top: 1px solid rgba(248, 215, 218, 0.1);\n  box-shadow: 0 -4px 20px rgba(158, 37, 54, 0.1);\n}\n.footer-inner { \n  display: flex; \n  align-items: center; \n  justify-content: space-between; \n  font-weight: 500;\n}\n.footer a { \n  color: #f8d7da; \n  text-decoration: none; \n  opacity: 0.9; \n  transition: all 0.3s ease;\n}\n.footer a:hover { \n  opacity: 1; \n  color: #ffffff;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n.footer-links { display:flex; gap:16px; }\n@media (max-width: 900px) { \n  .footer-inner { \n    flex-direction: column; \n    gap: 12px; \n    text-align: center;\n  } \n  \n  .footer {\n    padding: 24px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
